import React from 'react'

export default function Footer() {
  return (
    <footer id="footer">
        <a href={process.env.REACT_APP_WEBSITE} target="_blank" rel="noreferrer">Admin Panel</a> © All Rights Reserved.
    </footer>
  )
}
